import CommandPanel from './ui/CommandPanel.js';

// Footer v0.3.0 — command-panel skin on the same visual stack as the rest of
// the dashboard while preserving existing content and disclaimer tone.
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <CommandPanel className="border-t border-border mt-6">
      <footer className="border-t-0 px-4 py-4 text-center text-[11px] text-dim font-mono tracking-wide">
        <div>
          <span>© {year} AvenisLabs · All rights reserved.</span>
          <span className="mx-2 text-border">·</span>
          <span>
            Questions or suggestions:{' '}
            <a href="mailto:info@avenislabs.com" className="text-accent hover:underline">
              info@avenislabs.com
            </a>
          </span>
        </div>
        <div className="mt-2 max-w-3xl mx-auto text-muted/70 italic leading-relaxed">
          Disclaimer: any editorial statements on this site regarding questionable actions by a
          provider — including Tier-F (Untrustworthy) classifications, manual outage overrides,
          reputation grades, and accompanying notices — are solely the opinion of the site operator.
          They are not factual claims about the provider, not endorsed by any third party, and are
          subject to change as facts and the operator's view evolve.
        </div>
      </footer>
    </CommandPanel>
  );
}
